module.exports = __webpack_public_path__ + "static/img/Sub beam 3.0m (hollow 40x40x3.0m).51e8106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Sub beam 3.0m (hollow 40x40x3.0m).jpg
// module id = 101
// module chunks = 1